import styled from "@emotion/styled"
import { useState } from "react"
import { getAccordionItems, type AccordionItem } from "utils"
import AccordionItemComp from "./AccordionItem"

const StyledLayout = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
`

interface AccordionProps {
  data: any
  hideButton?: boolean
  initialClosed?: boolean
}

export default function AccordionComponent({
  data,
  hideButton = false,
  initialClosed,
}: AccordionProps) {
  const accordionItems: AccordionItem[] = getAccordionItems(data)
  const [openAccordion, setOpenAccordion] = useState<number | null>(
    initialClosed ? null : 0,
  )
  const handleAccordionToggle = (index: number) => {
    setOpenAccordion(openAccordion === index ? -1 : index)
  }

  return (
    <StyledLayout>
      {accordionItems.map((item, i) => (
        <AccordionItemComp
          key={i}
          item={item}
          index={i}
          isExpanded={openAccordion === i}
          onToggle={() => handleAccordionToggle(i)}
          hideButton={hideButton}
        />
      ))}
    </StyledLayout>
  )
}
